import api from '@/api'

var Q = require('q')

const state = {
  fileTypes: [],
  files: []
}

const getters = {
  fileTypes: (state) => state.fileTypes,
  files: (state) => state.files,
  filesByRegionAndType: (state) => (region, fileTypeCode) => {
    let files = []
    if (region) {
      files = state.files.filter(x => x.ID_REGION === region.ID_REGION && x.TIPO_FICHERO.CODIGO === fileTypeCode)
    }
    return files
  }
}

const mutations = {
  SET_FILE_TYPES (state, fileTypes) {
    state.fileTypes = fileTypes
  },
  SET_FILES (state, files) {
    state.files = files
  },
  ADD_FILE (state, file) {
    state.files.push(file)
  },
  ADD_FILES (state, files) {
    state.files.push(...files)
  },
  DELETE_FILE (state, file) {
    let index = state.files.findIndex(x => x.ID_FICHERO === file.ID_FICHERO)
    if (index !== -1) {
      state.files.splice(index, 1)
    }
  }
}

const actions = {
  async getFileTypes ({ commit }) {
    var deferred = Q.defer()

    try {
      const response = await api.file.getFileTypes()
      commit('SET_FILE_TYPES', response.data)

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  },

  async getFiles ({ commit }) {
    var deferred = Q.defer()

    try {
      const response = await api.file.getFiles()
      commit('SET_FILES', response.data)

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  },

  /* async downloadFile ({ commit }, file) {
    let result = await api.file.downloadFile(file)
    let contentType = result.headers['content-type']
    let contentDisposition = result.headers['content-disposition']

    let splitFilename = contentDisposition.split('filename="')
    let filename = splitFilename[splitFilename.length - 1].slice(0, -1)

    let blob = new Blob([result.data], { type: contentType })

    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
  }, */

  async downloadFile ({ commit }, file) {
    let vueVM = this._vm
    let toast = vueVM.$toastr.Add({
      name: file.NOMBRE,
      msg: file.NOMBRE,
      type: 'info',
      clickClose: false,
      timeout: 0,
      progressbar: true,
      style: { 'background-color': 'var(--v-primary-base)', 'font-family': 'Helvetica' },
      progressBarValue: 0
    })

    let result = await api.file.downloadFile(file, toast)

    vueVM.$toastr.Close(toast)
    toast = vueVM.$toastr.Add({
      name: file.NOMBRE,
      msg: file.NOMBRE + ' downloaded correctly',
      type: 'success',
      timeout: 3000
    })

    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(result.data)
    link.download = file.NOMBRE

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },

  async uploadFile ({ commit, dispatch }, data) {
    var deferred = Q.defer()

    try {
      const { file, fileItem, progressCallback } = data

      const formData = new FormData()
      formData.append('file', file)
      formData.append('ID_FICHERO', fileItem.ID_FICHERO)
      formData.append('ID_TIPO_FICHERO', fileItem.ID_TIPO_FICHERO)
      formData.append('ID_REGION', fileItem.ID_REGION)
      formData.append('ID_USUARIO', fileItem.ID_USUARIO)
      formData.append('NOMBRE', fileItem.NOMBRE)
      formData.append('FORMATO', fileItem.FORMATO)
      formData.append('DESCRIPCION', fileItem.DESCRIPCION)
      formData.append('FECHA', fileItem.FECHA)
      formData.append('SIZE_KB', fileItem.SIZE_KB)

      const response = await api.file.uploadFile(formData, progressCallback)

      commit('ADD_FILE', response.data)

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  },

  addFiles ({ commit }, files) {
    commit('ADD_FILES', files)
  },

  async deleteFile ({ commit, dispatch }, file) {
    var deferred = Q.defer()

    try {
      /* const response = */ await api.file.deleteFile(file)
      commit('DELETE_FILE', file)

      deferred.resolve()
    } catch (e) {
      console.error(e)
      deferred.reject()
    }

    return deferred.promise
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
